import { Component, h, ComponentInterface, State, Prop } from '@stencil/core';
import { guid } from 'utils';


@Component({
  tag: 'kdx-card-links',
  styleUrl: 'kdx-card-links.scss',
  shadow: false
})
export class StCardLinks implements ComponentInterface {

  @State() guid: string = guid();

  @Prop() componentScope: string;

  render() {
    return (
      <div class={`kdx-card-links${this.componentScope ? ` ${this.componentScope}-card-links` : ''}`}>
        <div class="container-fluid">
          <div class="row">
            <slot />
          </div>
        </div>
      </div>
    );
  }
}